/**
 * Registers the React rendering components for built-in module types.
 * This file is imported by ContainerRendererV2 to ensure components are
 * registered before any rendering occurs.
 *
 * To add a new module type:
 * 1. Register it in the module registry (moduleRegistry.ts) with a type and name
 * 2. Create the component in this folder
 * 3. Call registerModuleComponent() here to associate the component
 *
 * This separation avoids circular dependencies between the registry
 * (in Types/) and the rendering components (in Components/).
 */
import { registerModuleComponent } from '../../Types/containerV2/moduleRegistry';
import ButtonModule from './ButtonModule';
import { HtmlCodeModule, SharedCssModule } from './ImportedCodeModules';
import ConfirmReadModule from './ConfirmReadModule';
import CookieButtonModule from './CookieButtonModule';
import WelcomeGuideButtonModule from './WelcomeGuideButtonModule';
import TextModule from './TextModule';
import ImageModule from './ImageModule';
import DividerModule from './DividerModule';
import AnimatedSvgModule from './AnimatedSvgModule';
import BizAgentModule from './BizAgentModule';
import VideoModule from './VideoModule';
import IFrameModule from './IFrameModule';
import SegmentModule from './SegmentModule';
import FormModule from './FormModule';
import ObjectListModule from './ObjectListModule';

registerModuleComponent('Button', ButtonModule);
registerModuleComponent('HtmlCode', HtmlCodeModule);
registerModuleComponent('SharedCss', SharedCssModule);
registerModuleComponent('ConfirmRead', ConfirmReadModule);
registerModuleComponent('CookieButton', CookieButtonModule);
registerModuleComponent('WelcomeGuideButton', WelcomeGuideButtonModule);
registerModuleComponent('Text', TextModule);
registerModuleComponent('Image', ImageModule);
registerModuleComponent('Divider', DividerModule);
registerModuleComponent('AnimatedSvg', AnimatedSvgModule);
registerModuleComponent('BizAgent', BizAgentModule);
registerModuleComponent('Video', VideoModule);
registerModuleComponent('IFrame', IFrameModule);
registerModuleComponent('Segment', SegmentModule);
registerModuleComponent('Form', FormModule);
registerModuleComponent('ObjectList', ObjectListModule);
